import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=0befd914&scoped=true&lang=html&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"
import style0 from "./notice.vue?vue&type=style&index=0&id=0befd914&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0befd914",
  null
  
)

component.options.__file = "notice.vue"
export default component.exports